export default __webpack_public_path__ + "static/media/brand-round.dee2d5e2.png";